import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ApiService } from 'src/app/core/http/api.service';
import { SharedModule } from 'src/app/shared/modules/primeng.module';
import { AuthService } from 'src/app/core/auth/auth.service';
import { ApiCore } from 'src/app/config/api';
import { ToastService } from 'src/app/shared/services/toast.service';
import { HttpErrorResponse } from '@angular/common/http';
import { SessionService } from 'src/app/core/auth/session.service';
import { IError, IResetPassword } from 'src/app/models/Auth/AuthInterfaces';
import { LoginModalComponent } from '../login-modal/login-modal.component';

@Component({
  selector: 'app-restore-password-component',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './restore-password-component.html',
  styleUrls: ['./restore-password-component.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RestorePasswordComponentComponent implements OnInit {
  logo: string = 'assets/images/no-photo-available.png';
  restorePasswordForm: FormGroup;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  processing: boolean = false;
  @Input() showModal: boolean = false;
  @Output() hideModal = new EventEmitter<void>();
  constructor(
    private formBuilder: FormBuilder,
    private api: ApiService,
    private authService: AuthService,
    private toast: ToastService,
    private session: SessionService,
    private LoginModalComponent: LoginModalComponent
  ) {
    this.restorePasswordForm = this.formBuilder.group({
      newPassword: ['', [Validators.required, this.newPasswordValidator()]],
      confirmPassword: [
        '',
        [Validators.required, this.confirmPasswordValidator()],
      ],
    });
  }
  ngOnInit(): void {
    this.getCasinoConfig();
  }
  onHide() {
    this.processing = false;
    this.hideModal.emit();
    this.restorePasswordForm.reset();
  }
  private newPasswordValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;

      if (!value) return null;

      if (value.length < 8) {
        return { custom: `Utiliza al menos 8 caracteres` };
      }

      if (!/[0-9]/.test(value)) {
        return { custom: `Utiliza al menos 1 número` };
      }

      if (!/[A-Z]/.test(value)) {
        return { custom: `Utiliza al menos una letra mayúscula` };
      }

      if (!/[a-z]/.test(value)) {
        return { custom: `Utiliza al menos una letra minúscula` };
      }

      if (!/[!¡°'¬≠«≤≥…–^@#$%^&*(),.¿?":{}|<>[\]\/;:_+`~=\\-]/.test(value)) {
        return { custom: `Utiliza al menos 1 caracter especial` };
      }

      if (/\s/.test(value)) {
        return { custom: ` ` };
      }

      this.restorePasswordForm.get('confirmPassword')?.updateValueAndValidity();

      return null;
    };
  }
  private confirmPasswordValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (!value) return null;

      if (value !== this.restorePasswordForm.get('newPassword')?.value) {
        return { custom: `Contraseña no es igual` };
      }

      return null;
    };
  }
  changePassword() {
    this.processing = true;
    const resetPassword = {
      playerName: this.LoginModalComponent.loginForm.get('user')?.value,
      password: this.restorePasswordForm.get('newPassword')?.value,
    };

    this.authService
      .recoverPassword(resetPassword, ApiCore.RESER_PASSWORD_ONLY)
      .subscribe(
        async (resp: IResetPassword) => {
          this.processing = false;

          if (resp.statusCode === 403) {
            this.toast.showError('Código inválido, favor de verificar', '');
            return;
          }
          this.toast.showSuccess(
            'Contraseña actualizada satisfactoriamente',
            ''
          );

          this.session.removeItem('recoveryEmail');
          this.showModal = false;
          this.LoginModalComponent.emitHideModal();
          this.LoginModalComponent.showResetPasswordModal = false;
          this.LoginModalComponent.processing = false;
          this.LoginModalComponent.loginForm
            .get('user')
            ?.setValue(resp.userName);
          this.LoginModalComponent.loginForm.get('password')?.setValue('');
        },
        (error: HttpErrorResponse) => {
          this.processing = false;
          const RecoverError: IError = error.error;
          console.error(RecoverError);
          if (RecoverError.statusCode === 400) {
            this.toast.showError('Código inválido, favor de verificar', '');
            return;
          }
          this.toast.showError('Código inválido, favor de verificar', '');
        }
      );
  }
  private getCasinoConfig(): void {
    this.api.getCoorporateCasinoConfig().subscribe({
      next: (res) => {
        if (res.data.logoCasinoUrl) {
          this.logo = res.data.logoCasinoUrl;
        }
      },
      error: (err) => console.error(err),
    });
  }
}
